import { Button } from "react-bootstrap";
import { useAuthContext } from "../../lib/context/auth";

const SuperButton = (props) => {
  const { user } = useAuthContext();

  if (!user?.isSuperuser) return null;

  return <Button {...props} />;
};

export default SuperButton;
